(function () {
    'use strict';

    angular
        .module('skillsApp')
        .constant('appStates', {
            
            states: [
                {
                    name: 'maintenance',
                    url: '/skills/maintenance',
                    templateUrl: '/app/routes/maintenance.tpl.html',
                    controller: 'MaintenanceController',
                    controllerAs: 'vm'
                }, {
                    name: 'error',
                    url: '/skills/error',
                    templateUrl: '/app/routes/error.tpl.html',
                    controller: 'ErrorController',
                    controllerAs: 'vm',
                    params: {
                        error: { dynamic: true }
                    }
                }, {
                    name: 'oidc-callback',
                    url: '/skills/oidc-callback', // handled in skills-app-module.js
                    template: '<div></div>'
                }, {
                    name: 'oidc-silent-callback',
                    url: '/skills/oidc-silent-callback', // handled in skills-app-module.js
                    template: '<div></div>'
                }, {
                    name: 'app-main',
                    url: '/skills',
                    abstract: true,
                    templateUrl: '/app/routes/app-main.tpl.html',
                    controller: 'AppMainController',
                    controllerAs: 'vm'
                }, {
                    name: 'app-main.employee',
                    url: '/employee',
                    templateUrl: '/app/routes/employee.tpl.html',
                    controller: 'EmployeeController',
                    controllerAs: 'vm'
                }, {
                    name: 'app-main.employee.userquality',
                    url: '/:id',
                    templateUrl: '/app/routes/userquality.tpl.html',
                    controller: 'UserQualityController',
                    controllerAs: 'vm',
                    params: {
                        id: { dynamic: true }
                    },
                    resolve: {
                        userQuality: ['$stateParams', 'dataService', function ($stateParams, dataService) {
                            return dataService.getUserQuality($stateParams.id);
                        }]
                    }
                }, {
                    name: 'app-main.admin-clusteractions',
                    url: '/admin/clusteractions',
                    templateUrl: '/app/routes/admin/clusteractions.tpl.html',
                    controller: 'AdminClusterActionsController',
                    controllerAs: 'vm',
                    data: {
                        authorizedRoles: ['admin', 'manager']
                    },
                    resolve: {
                        clusterTypes: ['dataService', function (dataService) {
                            return dataService.getClusterTypes();
                        }]
                    },
                    ncyBreadcrumb: {
                        label: "{{ 'admin' | translate }}: {{ 'skills' | translate }} + {{ 'assignments' | translate }}"
                    }
                }, {
                    name: 'app-main.admin-clusteractions.edit-clusteraction',
                    url: '/edit-clusteraction/:id',
                    templateUrl: '/app/routes/admin/clusteractions/edit-clusteraction.tpl.html',
                    controller: 'EditClusterActionController',
                    controllerAs: 'vm',
                    data: {
                        authorizedRoles: ['admin']
                    },
                    params: {
                        id: { dynamic: true }
                    },
                    resolve: {
                        clusterAction: ['$stateParams', 'dataService', function ($stateParams, dataService) {
                            if (!$stateParams.id) return {};
                            return dataService.getClusterAction($stateParams.id);
                        }],
                        catalogItems: ['catalogService', function (catalogService) {
                            return catalogService.getCatalogItems();
                        }]
                    },
                    ncyBreadcrumb: {
                        label: "{{ 'edit_skill' | translate }}"
                    }
                }, {
                    name: 'app-main.admin-clusteractions.individuals',
                    url: '/individuals/:id',
                    templateUrl: '/app/routes/admin/clusteractions/individuals.tpl.html',
                    controller: 'AdminClusterActionsIndividualsController',
                    controllerAs: 'vm',
                    data: {
                        authorizedRoles: ['admin','manager']
                    },
                    params: {
                        id: { dynamic: true }
                    },
                    resolve: {
                        skill: ['$stateParams', 'dataService', function ($stateParams, dataService) {
                            return dataService.getSkill($stateParams.id);
                        }]
                    },
                    ncyBreadcrumb: {
                        label: "{{ 'individual' | translate }}"
                    }
                }, {
                    name: 'app-main.admin-clusteractions.individuals.edit-skill',
                    url: '/edit-skill',
                    templateUrl: '/app/routes/admin/clusteractions/edit-skill.tpl.html',
                    controller: 'EditSkillController',
                    controllerAs: 'vm',
                    data: {
                        authorizedRoles: ['admin','manager']
                    },
                    resolve: {
                        skill: ['$stateParams', 'dataService', function ($stateParams, dataService) {
                            return dataService.getSkill($stateParams.id);
                        }],
                        catalogItems: ['catalogService', function (catalogService) {
                            return catalogService.getCatalogItems();
                        }]
                    },
                    ncyBreadcrumb: {
                        label: "{{ 'edit_skill' | translate }}"
                    }

                }, {
                    name: 'app-main.admin-clusteractions.individuals.userquality',
                    url: '/userquality',
                    templateUrl: '/app/routes/userquality.tpl.html',
                    controller: 'UserQualityController',
                    controllerAs: 'vm',
                    params: {
                        id: { dynamic: true }
                    },
                    data: {
                        authorizedRoles: ['admin','manager']
                    },
                    resolve: {
                        userQuality: ['$stateParams', 'dataService', function ($stateParams, dataService) {
                            return dataService.getUserQuality($stateParams.id);
                        }],
                        catalogItems: ['catalogService', function (catalogService) {
                            return catalogService.getCatalogItems();
                        }]
                    },
                    ncyBreadcrumb: {
                        label: "{{ 'edit_skill' | translate }}"
                    }
                }, {
                    name: 'app-main.admin-clusteractions.functions',
                    url: '/functions/:id',
                    templateUrl: '/app/routes/admin/clusteractions/functions.tpl.html',
                    controller: 'AdminClusterActionsFunctionsController',
                    controllerAs: 'vm',
                    params: {
                        id: { dynamic: true }
                    },
                    data: {
                        authorizedRoles: ['admin','manager']
                    },
                    resolve: {
                        clusterAction: ['$stateParams', 'dataService', function ($stateParams, dataService) {
                            return dataService.getClusterAction($stateParams.id);
                        }]
                    },
                    ncyBreadcrumb: {
                        label: "{{ 'functions' | translate }}"
                    }
                }, {
                    name: 'app-main.admin-clusteractions.functions.add-skill',
                    url: '/add-skill',
                    templateUrl: '/app/routes/admin/clusteractions/add-skill.tpl.html',
                    controller: 'AddSkillController',
                    controllerAs: 'vm',
                    params: {
                        id: { dynamic: true }
                    },
                    data: {
                        authorizedRoles: ['admin','manager']
                    },
                    resolve: {
                        clusterAction: ['$stateParams', 'dataService', function ($stateParams, dataService) {
                            return dataService.getClusterAction($stateParams.id);;
                        }],
                        catalogItems: ['catalogService', function (catalogService) {
                            return catalogService.getCatalogItems();
                        }]
                    },
                    ncyBreadcrumb: {
                        label: "{{ 'assign' | translate }}"
                    }
                }, {
                    name: 'app-main.admin-clusteractions.functions.edit-skill',
                    url: '/edit-skill/:skillId',
                    templateUrl: '/app/routes/admin/clusteractions/edit-skill.tpl.html',
                    controller: 'EditSkillController',
                    controllerAs: 'vm',
                    params: {
                        skillId: { dynamic: true }
                    },
                    data: {
                        authorizedRoles: ['admin','manager']
                    },
                    resolve: {
                        skill: ['$stateParams', 'dataService', function ($stateParams, dataService) {
                            return dataService.getSkill($stateParams.skillId);
                        }],
                        catalogItems: ['catalogService', function (catalogService) {
                            return catalogService.getCatalogItems();
                        }]
                    },
                    ncyBreadcrumb: {
                        label: "{{ 'edit_skill' | translate }}"
                    }
                }, {
                    name: 'app-main.admin-employees',
                    url: '/admin/employees',
                    templateUrl: '/app/routes/admin/employees.tpl.html',
                    controller: 'AdminEmployeesController',
                    controllerAs: 'vm',
                    data: {
                        authorizedRoles: ['admin','manager','assessor']
                    },
                    ncyBreadcrumb: {
                        label: "{{ 'admin' | translate }}: {{ 'employees' | translate }}"
                    }
                }, {
                    name: 'app-main.admin-examiners',
                    url: '/admin/examiners',
                    templateUrl: '/app/routes/admin/examiners.tpl.html',
                    controller: 'AdminExaminersController',
                    controllerAs: 'vm',
                    data: {
                        authorizedRoles: ['admin','manager']
                    },
                    resolve: {
                        allExaminerClusterActions: ['$stateParams', 'dataService', function ($stateParams, dataService) {
                            return dataService.getExaminerClusterActions();
                        }]
                    },
                    ncyBreadcrumb: {
                        label: "{{ 'admin' | translate }}: {{ 'examiners' | translate }}"
                    }
                }, {
                    name: 'app-main.admin-employees.userquality',
                    url: '/:id',
                    templateUrl: '/app/routes/userquality.tpl.html',
                    controller: 'UserQualityController',
                    controllerAs: 'vm',
                    params: {
                        id: { dynamic: true }
                    },
                    data: {
                        authorizedRoles: ['admin','manager','assessor']
                    },
                    resolve: {
                        userQuality: ['$stateParams', 'dataService', function ($stateParams, dataService) {
                            return dataService.getUserQuality($stateParams.id);
                        }],
                        catalogItems: ['catalogService', function (catalogService) {
                            return catalogService.getCatalogItems();
                        }]
                    },
                    ncyBreadcrumb: {
                        label: "{{ 'edit_skill' | translate }}"
                    }
                }, {
                    name: 'app-main.admin-departments',
                    url: '/admin/departments',
                    templateUrl: '/app/routes/admin/departments.tpl.html',
                    controller: 'AdminDepartmentsController',
                    controllerAs: 'vm',
                    data: {
                        authorizedRoles: ['admin', 'manager']
                    },
                    resolve: {
                        departments: ['config','portalGroupService', function (config, portalGroupService) {
                            return portalGroupService.getGroups(config.settings.user.isAdmin);
                        }],
                        groupsAndFunctions: ['portalGroupService', function (portalGroupService) {
                            return portalGroupService.getAllGroupsAndFunctions();
                        }]
                    },
                    ncyBreadcrumb: {
                        label: "{{ 'admin' | translate }}: {{ 'departments' | translate }}"
                    }
                }, {
                    name: 'app-main.admin-departments.userquality',
                    url: '/userquality/:id',
                    templateUrl: '/app/routes/userquality.tpl.html',
                    controller: 'UserQualityController',
                    controllerAs: 'vm',
                    params: {
                        id: { dynamic: true }
                    },
                    data: {
                        authorizedRoles: ['admin', 'manager']
                    },
                    resolve: {
                        userQuality: ['$stateParams', 'dataService', function ($stateParams, dataService) {
                            return dataService.getUserQuality($stateParams.id);
                        }],
                        catalogItems: ['catalogService', function (catalogService) {
                            return catalogService.getCatalogItems();
                        }]
                    },
                    ncyBreadcrumb: {
                        label: "{{ 'edit_skill' | translate }}"
                    }
                }, {
                    name: 'app-main.admin-settings',
                    url: '/admin/settings',
                    templateUrl: '/app/routes/admin/settings.tpl.html',
                    controller: 'AdminSettingsController',
                    controllerAs: 'vm',
                    data: {
                        authorizedRoles: ['admin']
                    },
                    ncyBreadcrumb: {
                        label: "{{ 'admin' | translate }}: {{ 'settings' | translate }}"
                    }
                }, {
                    name: 'app-main.reports-skills',
                    url: '/reports/skills',
                    templateUrl: '/app/routes/reports/skills.tpl.html',
                    controller: 'ReportsSkillsController',
                    controllerAs: 'vm',
                    data: {
                        authorizedRoles: ['admin', 'manager', 'skills-report-viewer']
                    },
                    resolve: {
                        departments: ['config', 'portalGroupService', function (config, portalGroupService) {
                            return portalGroupService.getGroups(config.settings.user.isAdmin || (config.settings.user.isReportViewer && config.settings.reportViewerSettings.showSkillsReport));
                        }],
                        groupsAndFunctions: ['portalGroupService', function (portalGroupService) {
                            return portalGroupService.getAllGroupsAndFunctions();
                        }]
                    },
                    ncyBreadcrumb: {
                        label: "{{ 'reports' | translate }}: {{ 'skills' | translate }}"
                    }
                }, {
                    name: 'app-main.reports-departments',
                    url: '/reports/departments',
                    templateUrl: '/app/routes/reports/departments.tpl.html',
                    controller: 'ReportsDepartmentsController',
                    controllerAs: 'vm',
                    data: {
                        authorizedRoles: ['admin', 'manager', 'departments-report-viewer']
                    },
                    ncyBreadcrumb: {
                        label: "{{ 'reports' | translate }}: {{ 'departments' | translate }}"
                    }
                }
            ]
        });
})();